import styled from 'styled-components'
import UIBlockUnstyled from 'Containers/UIBlock/unstyled'

export const UIBlock = styled(UIBlockUnstyled)`
  .block-ui-container {
    position: fixed;
  }
  .loading-bullet {
    color: ${props => props.theme.colors.primary};
  }
`
